var template = require('./beneficiaries.html.slim')
declare var angular

export class ProfileBeneficiariesController {
  static $inject = ['ProfileBeneficiaries', 'brand', 'locale']

  userLocale: null
  brandName: null
  investmentAccounts: []
  error: null

  constructor(private ProfileBeneficiaries, private brand, private locale) {
    this.getInvestmentAccountStates()
    this.brandName = this.brand.getBrand();
    this.userLocale = this.locale.getLocale();
  }

  getInvestmentAccountStates() {
    return this.ProfileBeneficiaries.getState().$promise
      .then(resp => {
        this.investmentAccounts = resp.reduce((agg, curr) => {
          if (agg[curr.id]) {
            agg[curr.id].changeRequest = true
            // makes sure the signed is never omitted
            // so it can display data to client
            if (curr.signed) agg[curr.id] = Object.assign(agg[curr.id], curr)
          } else {
            agg[curr.id] = curr
            agg[curr.id].state = curr.data && curr.data.state
          }

          return agg
        }, {})
      })
  }

  extractData(data, key, id, deepKey) {
    return data[key + id + deepKey]
  }

  getLearnMoreUrl() {
    if (this.brandName === 'assante') {
      // ASSANTE
      if (this.userLocale === 'fr-ca') {
        // FRENCH
        return 'https://support.assanteconnect.com/questions-generales/nommer-un-beneficiaire'
      } else {
        // DEFAULT TO EN
        return 'https://support.assanteconnect.com/name-a-beneficiary?kb_language=en_US'
      }
    } else {
      // WEALTHBAR
      if (this.userLocale === 'fr-ca') {
        // FRENCH
        return 'https://help.cidirectinvesting.com/14778-questions-generales/comment-puis-je-nommer-un-bnficiaire-pour-mes-comptes-wealthbar'
      } else {
        // DEFAULT TO EN
        return 'https://help.cidirectinvesting.com/10762-general-questions/how-do-i-name-a-beneficiary-to-my-wealthbar-accounts'
      }
    }
  }
}

angular.module('wbComponents')
  .controller("ProfileBeneficiariesController", ProfileBeneficiariesController)
  .directive('profileBeneficiaries', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "ProfileBeneficiariesController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
